import { render, staticRenderFns } from "./PointTermsOfService.vue?vue&type=template&id=6db41ff4&scoped=true&"
import script from "./PointTermsOfService.vue?vue&type=script&lang=js&"
export * from "./PointTermsOfService.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6db41ff4",
  null
  
)

export default component.exports